import { Link } from 'react-router-dom'

function Footer() {

  var year = new Date().getFullYear()


  return (
    <footer className='bg-link text-center '>
      <div className='container p-3'>
        <section className='mb-1'>
          <p>
          UHDSS education agency supports students who want to study abroad, and provides guidance on immigration services,
          visitor, business and tourist visas, and other tourism services.
          </p>
          <p className='mb-0'>
            <Link className='text-dark' to='/student-commitment'>Student Commitment</Link>
            <span className='mx-2'>|</span>
            <Link className='text-dark' to='/complaints'>Complaints</Link>
            <span className='mx-2'>|</span>
            <Link className='text-dark' to='/privacy-policy'>Privacy Policy</Link>
          </p>
        </section>
      </div>

      <div className='text-center p-3'>
        ©  {`${year}`}  Copyright:
        <Link className='text-dark' to=''><strong> UHDSS</strong></Link>
      </div>


    </footer>
  )
}

export default Footer